module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset role="search"><label class="screen-reader-text" for="input-search">'+
((__t=( i18n.tc("SupportSearch", "Search") ))==null?'':__t)+
'</label><div class="search-field"><input type="search" id="input-search" data-input="search-search"> <button class="primary icon icon-material icon-search no-border" data-click="search-submit" aria-label="'+
((__t=( i18n.tc("SupportSearch", "Search") ))==null?'':__t)+
'">&nbsp;</button></div></fieldset>';
}
return __p;
};
